<style lang="scss" scoped>
.tab-skillsheet {
  width: 17% !important;
}
.tab-skillsheet ul li a.nav-link {
  color: #333;
}
.tab-skillsheet ul li a.nav-link.active {
  background: #3c4b64 !important;
  color: #fff;
}

@media screen and(max-width:767px) {
  .card-header {
    padding: 0.25rem 0.25rem;
  }
  .skill-sheet-employee .employees-form {
    padding: 0 0.25rem !important;
    margin-bottom: 0 !important;
  }
  .skill-sheet-employee .body .create-form .skill-experience label {
    margin-left: 52px !important;
  }

  .skill-type {
    display: none;
  }

  .skill-sheet-employee .body .create-form .title-form-header {
    margin-top: 10px;
  }
  .skill-sheet-employee {
    .body {
      .create-form {
        .card-body {
          padding: 0.25rem 0 !important;
        }
        .skill-level {
          width: 75% !important;
          display: flex;
          .skill-level__left {
            width: 25%;
            margin-left: 50px;
          }
          .skill-level__right {
            width: 75%;
            display: flex;
            justify-content: space-between !important;
          }
        }
      }
    }
  }
  .menuSkill {
    display: block;
  }
  .col-auto.mobile-screen-show-tab {
    display: block;
    width: 18%;
  }
  .ml-mobile-140 {
    margin-left: 140px;
  }
}
</style>
<style lang="scss" scoped>
.skill-sheet-employee {
  .employees-form {
    padding: 0 50px;
    margin-bottom: 30px;
    .title-header {
      font-weight: 600;
      font-size: 18px;
    }
    .table {
      border-color: rgba(0, 0, 21, 0.125);

      .description-rank {
        vertical-align: middle;
        border-color: rgba(0, 0, 21, 0.125);
      }
    }
  }

  .body {
    .create-form {
      .card-body {
        padding: 1.25rem 0 1.25rem 1.25rem;
      }
      .nav {
        padding: 20px 0 0 0;
      }
      .skill-btn {
        margin-top: 20px;
        text-align: center;

        .save-info {
          background: #b4daf3;
          font-weight: 600;
          padding: 7px 70px;
          color: #0d2e48;
          margin-right: 20px;
          border: 2px solid #b4daf3;
        }

        .cancel-info {
          padding: 7px 45px;
          font-weight: 600;
          background: #f6f6f6;
          border: 2px solid #0d2e48;
          color: #0d2e48;
          max-width: 300px;
        }
      }

      .skill-name {
        align-self: center;
        font-weight: bold;
      }

      .skill-rank {
        align-self: center;
      }

      .skill-experience {
        align-items: center;

        .delete-btn {
          color: red;
          margin-left: 20px;
        }

        .experience-time {
          margin-bottom: 0;
        }
      }

      .skill-description {
        margin-right: 15px;
        margin-left: 15px;
      }

      .skill-type {
        font-weight: bold;
        width: 20%;

        .toggle-list-skill {
          margin-left: 30px;
        }
      }
      .skill-level {
        width: 56%;
        display: flex;
        .skill-level__left {
          width: 25%;
        }
        .skill-level__right {
          width: 75%;
          display: flex;
          justify-content: space-around;
        }
      }
      .skill-experience {
        width: 24%;
        label {
          margin-left: 38px;
        }
      }
      .title-form-header {
        font-weight: bold;
        display: flex;
      }
    }
  }
}
.menuSkill {
  display: none;
}
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
  .skill-sheet-employee .employees-form {
    padding: 0 1.5rem;
  }
  .menuSkill {
    display: block !important;
  }
  .skill-type {
    display: none;
  }
  .body {
    margin-top: 7px;
    overflow: scroll;
    padding: 0;
  }
  .create-form {
    overflow: scroll;
    min-width: 900px;
  }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .skill-sheet-employee {
    .body {
      .create-form {
        .card-body {
          padding: 0.25rem 0 !important;
        }
        .skill-level {
          width: 75% !important;
          display: flex;
          .skill-level__left {
            width: 23%;
            margin-left: 50px;
          }
          .skill-level__right {
            width: 61%;
            display: flex;
            justify-content: space-between !important;
          }
        }
      }
    }
  }
  .ml-tablet-140 {
    margin-left: 140px;
  }
}
@media screen and(max-width: 767px) {
  .body {
    margin-top: 7px;
    overflow: scroll;
    padding: 0;
  }
  .create-form {
    overflow: scroll;
    min-width: 900px;
  }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .menuSkill {
    display: block !important;
  }
}
</style>
<style lang="scss">
@media only screen and (max-device-width: 1024px) {
  .tab-skillsheet {
    display: none;
  }
}
</style>
<template>
  <CRow class="skill-sheet-employee">
    <CCol md="12" sm="12" class="employees-form">
      <CCard>
        <CCardHeader>
          <CRow>
            <CCol md="12 table-mobile">
              <label class="title-header">{{
                $t("skill_sheet.label_title")
              }}</label>
            </CCol>
          </CRow>
          <CRow>
            <CCol md="12 table-mobile">
              <table border class="table">
                <tr>
                  <td rowspan="6" class="description-rank">
                    {{ $t("skill_sheet.label_description_of_ranking") }}
                  </td>
                  <td>0</td>
                  <td>{{ $t("skill_sheet.label_description_of_rank0") }}</td>
                </tr>
                <tr>
                  <td>1</td>
                  <td>{{ $t("skill_sheet.label_description_of_rank1") }}</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>{{ $t("skill_sheet.label_description_of_rank2") }}</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>{{ $t("skill_sheet.label_description_of_rank3") }}</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>{{ $t("skill_sheet.label_description_of_rank4") }}</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>{{ $t("skill_sheet.label_description_of_rank5") }}</td>
                </tr>
              </table>
            </CCol>
          </CRow>
        </CCardHeader>
        <CCardBody class="body">
          <span class="menuSkill" @click.prevent="showMenuSkill"
            ><CIcon size="2xl" name="cil-chevron-right"
          /></span>
          <CForm class="create-form" v-on:submit.prevent="createSkillSheet">
            <CRow
              :class="{
                'ml-mobile-140': menuStatus,
                'ml-tablet-140': menuStatus
              }"
            >
              <CCol md="12" class="title-form-header">
                <div class="skill-type">
                  {{ $t("skill_sheet.label_title_type_skill") }}
                </div>
                <div class="skill-level">
                  <div class="skill-level__left">
                    {{ $t("skill_sheet.label_title_skill") }}
                  </div>
                  <div class="skill-level__right">
                    <label class="rank-title rank0">{{
                      $t("skill_sheet.label_rank_0")
                    }}</label>
                    <label class="rank-title rank1">{{
                      $t("skill_sheet.label_rank_1")
                    }}</label>
                    <label class="rank-title rank2">{{
                      $t("skill_sheet.label_rank_2")
                    }}</label>
                    <label class="rank-title rank3">{{
                      $t("skill_sheet.label_rank_3")
                    }}</label>
                    <label class="rank-title rank4">{{
                      $t("skill_sheet.label_rank_4")
                    }}</label>
                    <label class="rank-title rank5">{{
                      $t("skill_sheet.label_rank_5")
                    }}</label>
                  </div>
                </div>
                <div class="skill-experience">
                  <label class="time">{{
                    $t("skill_sheet.label_experience_time")
                  }}</label>
                </div>
              </CCol>
            </CRow>
            <CRow>
              <CCol md="12">
                <b-tabs
                  pills
                  card
                  vertical
                  :nav-wrapper-class="
                    menuStatus === true
                      ? 'mobile-screen-show-tab'
                      : 'tab-skillsheet'
                  "
                >
                  <b-tab
                    title-item-class="mytab"
                    id="ads"
                    v-for="(skillNames, key) in skillSheet.skillName"
                    :key="key"
                    :title="skillSheet.skillType[key]"
                  >
                    <b-card-text>
                      <div
                        href="#"
                        class="d-flex list-group-item skill-description"
                        v-for="(skill, index) in skillNames"
                        :key="index"
                        md="12"
                      >
                        <CCol class="skill-name" md="2">
                          <label class="skill-name">{{ skill }}</label>
                        </CCol>
                        <CCol class="skill-rank" md="7">
                          <div class="d-flex justify-content-around">
                            <label class="form-check-inline rank-option">
                              <input
                                type="radio"
                                class="form-check-input"
                                v-model="selectedSkill[skill]"
                                value="0"
                                disabled
                              />
                            </label>
                            <label class="form-check-inline rank-option">
                              <input
                                type="radio"
                                class="form-check-input"
                                v-model="selectedSkill[skill]"
                                value="1"
                                disabled
                              />
                            </label>
                            <label class="form-check-inline rank-option">
                              <input
                                type="radio"
                                class="form-check-input"
                                v-model="selectedSkill[skill]"
                                value="2"
                                disabled
                              />
                            </label>
                            <label class="form-check-inline rank-option">
                              <input
                                type="radio"
                                class="form-check-input"
                                v-model="selectedSkill[skill]"
                                value="3"
                                disabled
                              />
                            </label>
                            <label class="form-check-inline rank-option">
                              <input
                                type="radio"
                                class="form-check-input"
                                v-model="selectedSkill[skill]"
                                value="4"
                                disabled
                              />
                            </label>
                            <label class="form-check-inline rank-option">
                              <input
                                type="radio"
                                class="form-check-input"
                                v-model="selectedSkill[skill]"
                                value="5"
                                disabled
                              />
                            </label>
                          </div>
                        </CCol>
                        <CCol class="skill-experience d-flex" md="3">
                          <CInput
                            class="experience-time"
                            type="text"
                            v-model="selectedExperience[skill]"
                            disabled
                          ></CInput>
                        </CCol>
                      </div>
                    </b-card-text>
                  </b-tab>
                </b-tabs>
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import "sweetalert2/src/sweetalert2.scss";

export default {
  props: {
    employee: {
      type: Object,
      default: () => []
    }
  },
  data() {
    return {
      selectedSkill: {},
      selectedExperience: {},
      menuStatus: false
    };
  },
  created() {
    this.showSkillSheet();
  },
  computed: {
    ...mapGetters({
      skillSheet: "skillsheet/skillSheet"
    })
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    async showSkillSheet() {
      let employeeId = await this.$route.params.id;
      if (employeeId) {
        await this.$store.dispatch("skillsheet/showSkillSheet", employeeId);
      }
      this.selectedSkill = this.skillSheet.skillCheckRank;
      this.selectedExperience = this.skillSheet.skillCheckExperience;
    },
    showMenuSkill() {
      this.menuStatus = !this.menuStatus;
    }
  }
};
</script>
